import React, { useState } from "react";
import styles from "./_css/searchBarGeoZone.module.css";
import { observer } from "mobx-react";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { URLS } from "_configs/URLS";
import { PROPERTY_PURPOSE, PROPERTY_TYPE } from "properties/_models/PropertyMdl";
import { useHistory } from "react-router-dom";
import { propertiesBuyingStore } from "properties/_stores/propertiesBuyingStore";
import { propertiesRentingStore } from "properties/_stores/propertiesRentingStore";
import { TGeoZoneMdl } from "geoZones/_models/GeoZoneMdl";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { SearchBarResult } from "properties/searchBar/SearchBarResult";
import { Paper } from "@material-ui/core";
import { combineLoadingStates } from "_common/loaders/loadingStateUtils";
import { propertiesStore } from "properties/_stores/propertiesStore";
import { DEFAULT_MAP_COORDINATES_ZONE, fetchSearchProperties } from "_common/_utils/searchUtils";
import { SearchBarInput } from "properties/searchBar/SearchBarInput";
import { settingsStore } from "settings/_stores/settingsStore";
import clsx from "clsx";
import { TFilterType } from "admin/_common/resources/ResourceFilterMdl";
import { ListStore } from "_common/list/ListStore";
import { FILTER_KEYS } from "properties/searchBar/filters/_utils/filtersUtils";
import { homeSearchStore } from "home/_stores/homeSearchStore";

type Props = {
    isHomePage?: boolean;
    purpose: PROPERTY_PURPOSE;
    onSelectGeoZone?: (geoZone: TGeoZoneMdl) => void;
    onSelectProperty?: (aliasUrl: string) => void;
    propertyType?: PROPERTY_TYPE;
};

export const SearchBarGeoZoneAndProperties = observer((props: Props) => {
    const [value, setValue] = useState(geoZonesStore.geoZone?.name ?? "");
    const history = useHistory();
    const propertiesBuyingOrRentingStore =
        props.purpose === PROPERTY_PURPOSE.BUY ? propertiesBuyingStore : propertiesRentingStore;

    // Sur l'accueil, applique le type de propriété sélectionné via les chips au filtre de recherche.
    const applyHomePropertyTypeFilter = (listStore: ListStore<TPropertyListingMdl>) => {
        if (!props.isHomePage) return;
        listStore.removeFilterByFilterId(FILTER_KEYS.TYPE);
        if (homeSearchStore.propertyType) {
            listStore.filters.push({
                id: FILTER_KEYS.TYPE,
                type: TFilterType.IN,
                value: [homeSearchStore.propertyType],
            });
        }
    };

    const onSelectGeoZone = (geoZone: TGeoZoneMdl) => {
        setValue(geoZone.name);
        geoZonesStore.setGeoZone(geoZone);
        propertiesStore.setLocationFromSearch(geoZone);
        propertiesBuyingStore.setLocationFromSearch(geoZone);
        propertiesRentingStore.setLocationFromSearch(geoZone);
        applyHomePropertyTypeFilter(propertiesBuyingOrRentingStore.listsStores[props.purpose]);
        fetchSearchProperties(
            propertiesBuyingOrRentingStore,
            propertiesBuyingOrRentingStore.listsStores[props.purpose],
            history,
        );
        geoZonesStore.open(false);
        settingsStore.close();
    };

    return (
        <div className={"position_relative h-full w-full"}>
            <SearchBarInput
                onSelectGeoZone={(geoZone) => onSelectGeoZone(geoZone)}
                onSelectProperty={(urlAlias) => history.push(URLS.property(urlAlias))}
                isHomePage={props.isHomePage}
                purpose={props.purpose}
                value={value}
                setValue={setValue}
                onClickOnSearchIcon={() => {
                    {
                        const store =
                            props.purpose === PROPERTY_PURPOSE.BUY ? propertiesBuyingStore : propertiesRentingStore;
                        if (store.getListStore(props.purpose).filters.length < 2) {
                            store.getListStore(props.purpose).filters.push({
                                id: "purpose",
                                type: TFilterType.ENUM,
                                value: props.purpose,
                            });
                            store.getListStore(props.purpose).filters.push({
                                id: "location",
                                type: TFilterType.ZONE,
                                value: DEFAULT_MAP_COORDINATES_ZONE,
                            });
                        }
                        applyHomePropertyTypeFilter(store.getListStore(props.purpose));
                        fetchSearchProperties(store, store.listsStores[props.purpose], history);
                    }
                }}
            />
            {geoZonesStore.isSearching && (
                <div id={"searchBarResult"} className={clsx(styles.searchResult, "w-full")}>
                    <Paper elevation={1} className={styles.container}>
                        <LoadableFromLoading
                            className={styles.loader}
                            noSpinner
                            loading={combineLoadingStates([
                                propertiesStore.propertiesSearchState,
                                geoZonesStore.geoZonesState,
                            ])}
                            renderer={() => (
                                <SearchBarResult
                                    purpose={props.purpose}
                                    onSelectGeoZone={(geoZone) => {
                                        onSelectGeoZone(geoZone);
                                    }}
                                    onSelectProperty={(urlAlias) => history.push(URLS.property(urlAlias))}
                                />
                            )}
                        />
                    </Paper>
                </div>
            )}
        </div>
    );
});
